import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchImageData, fetchViewAssReortsData } from '../reduxactions/suprivisoractions/SupViewAssActions';
import { useLocation, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import useEffectOnce from '../hooks/useEffectOnce';

export const SupViewAssReports = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const image = useSelector((state: RootState) => state.sviewassreports.image);
    const getdata = useSelector((state: RootState) => state.sviewassreports.data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchImageData(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchViewAssReortsData(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataAsync1();
    }, [dispatch]);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewsup-assisten.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <div className="col-16" style={{ textAlign: "right" }}>
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                        <section className="content">
                            {image.map((response: any) =>
                                <div className="grid">
                                    <div className="col-3">
                                        <Panel header="" >
                                            <div className="widget-user-header bg-info" style={{ height: '100px', backgroundColor: 'rgb(23, 162, 184)' }}>
                                                <h3 className="widget-user-username" style={{ color: 'rgb(255, 255, 255)' }}>Assistant</h3>
                                            </div>

                                            < img src={response.photo} alt="Logo" width="220px" height="100%" />
                                        </Panel>

                                    </div>
                                    <div className="col-9">
                                        {getdata.map((response: any, index: number) => (
                                            <section className="content" key={index}>
                                                <Card title="" style={{ marginRight: '50px', maxWidth: '600px', margin: '0 auto' }}> {/* Adjust the maxWidth here */}
                                                    <Panel header="Assistant Details">
                                                        <div className="grid">
                                                            <div className="col-12 md:col-12 lg:col-6">
                                                                {[
                                                                    { label: ' Name:', value: `${response.FirstName} ${response.LastName}` },
                                                                    { label: 'Email:', value: response.Email },
                                                                    { label: 'Phone :', value: response.Phone },
                                                                    { label: 'Address:', value: `${response.FirstName} ${response.LastName} ${response.Address} ${response.City}` },
                                                                    { label: 'Hospital:', value: response.hospitalname },
                                                                ].map((item, idx) => (
                                                                    <div
                                                                        className="grid"
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginBottom: '10px'
                                                                        }}
                                                                        key={idx}
                                                                    >
                                                                        <strong
                                                                            style={{
                                                                                width: '55px',
                                                                                textAlign: 'right',
                                                                                paddingRight: '15px',
                                                                                minWidth: '50px'
                                                                            }}
                                                                        >
                                                                            {item.label}
                                                                        </strong>
                                                                        <p
                                                                            className="text-muted"
                                                                            style={{
                                                                                marginLeft: '10px',
                                                                            }}
                                                                        >
                                                                            {item.value}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Panel>
                                                </Card>
                                            </section>
                                        ))}
                                    </div>


                                </div>
                            )}
                        </section >

                    </div >
                </div>
            </div>
        </div>
    )
}
